export default __webpack_public_path__ + "static/media/times.4cb3b202.png";